import { Link } from 'react-router-dom';
import Logotext from '../logotext';
import { paths } from '../../routing';

const Header = () => {
  return (
    <header>
      <h1>
        <Link to={paths.home} aria-label="Home">
          <Logotext isFull />
        </Link>
      </h1>
    </header>
  );
};

export default Header;
